<template>
  <div class="MenuList">
    <modal
      name="AddMenu"
      width="60%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="true"
      style="overflow:scroll"
    >
      <FormAddMenu labelAction="Agregar Sub Item" :IdForm="this.$route.params.idMenu" :method="reloadMenu" v-if="renderComponent1"/>
    </modal>
    <modal
      name="EditMenu"
      width="60%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="true"
      style="overflow:scroll"
    >
      <FormEditMenu labelAction="Editar Sub Item" :method="reloadMenu" :ModelForm="formUpdate"  v-if="renderComponent2"/>
    </modal>
    <div class="titlePage">Administracion - Menú - {{this.$route.params.nameMenu}}</div>
    <va-notification
      color="danger"
      v-if="refNoMenu"
      class="refNoData"
    >No se encuentran sub menus activos para el menú: {{this.$route.params.nameMenu}}.</va-notification>
      <div class="row">
        <div class="col-md-6 text-left">
            <button class="loginbtn primaryBtn" type="submit" v-on:click="LinkMenu()">
            <va-icon name="fa fa-arrow-left" size="60" /> Regresar al menú Principal
            </button>
        </div>
      </div>
    <div class="MenuData table-responsive">
      <br/>
      <table class="table table-hover" id="myTable">
        <thead>
          <tr>
            <th scope="col" colspan="3"></th>
            <th scope="col" class="status text-center" colspan="4">Estados</th>
            <th scope="col" ></th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Etiqueta</th>
            <th scope="col">Link</th>
            <th scope="col" class="status text-center">Orden</th>
            <th scope="col" class="status text-center">Inicio</th>
            <th scope="col" class="status text-center">Visible</th>
            <th scope="col" class="status text-center">Estado</th>
            <th scope="col" class="text-center">Acciones</th>
          </tr>
        </thead>
        <draggable tag="tbody" v-model="dataMenu" @start="drag=true" @end="drag=false">
          <template v-for="item of dataMenu">
            <tr class="item" :key="item.Id_Menu">
              <th scope="row">{{item.Id_Menu}}</th>
              <td>{{item.Nam_Menu}}</td>
              <td>{{item.Des_MenuRoot}}</td>
              <td class="status text-center">{{item.Des_OrderBy}}</td>
              <td class="status text-center">
                  <img v-if="item.Sta_ShortCuts === true" class="imgdata ma-0" :id="item.Id_Menu" src="../../assets/images/user_check.png" width="20"  @click="uptMenuActions(item,'Short',false)" alt="Acceso" title="Acceso"/>
                  <img v-else class="imgdata ma-0" :id="item.Id_Menu" src="../../assets/images/user_inactive.png" width="20"  @click="uptMenuActions(item,'Short',true)" alt="Sin Acceso" title="Sin Acceso"/>
              </td>
              <td class="status text-center">
                  <img v-if="item.Is_View === true" class="imgdata ma-0" :id="item.Id_Menu" src="../../assets/images/user_check.png" width="20"  @click="uptMenuActions(item,'View',false)" alt="Visible" title="Visible"/>
                  <img v-else class="imgdata ma-0" :id="item.Id_Menu" src="../../assets/images/user_inactive.png" width="20"  @click="uptMenuActions(item,'View',true)" alt="No Visible" title="No Visible"/>
              </td>
              <td class="status text-center">
                  <img v-if="item.Sta_Active === true" class="imgdata ma-0" :id="item.Id_Menu" src="../../assets/images/user_check.png" width="20"  @click="uptMenuActions(item,'Active',false)" alt="Activo" title="Activo"/>
                  <img v-else class="imgdata ma-0" :id="item.Id_Menu" src="../../assets/images/user_inactive.png" width="20"  @click="uptMenuActions(item,'Active',true)" alt="Inactivo" title="Inactivo"/>
              </td>
              <td class="text-center">
                  <img class="imgdata ma-0" :id="item.Id_Menu" src="../../assets/images/edit.png" alt="Editar" title="Editar" width="20"  @click="editMenu(item)"/>
              </td>
            </tr>
          </template>
        </draggable>
      </table>
    </div>
    <div class="row">
      <div class="col-md-6 text-center">
        <button class="loginbtn primaryBtn" type="submit" v-on:click="this.addMenu">
          <va-icon name="fa fa-database" size="60" /> Agregar Nuevo Sub Item
        </button>
      </div>
      <div class="col-md-6 text-center">
        <button class="loginbtn primaryBtn" type="submit" v-on:click="this.UpdateMenuList">
          <va-icon name="fa fa-refresh" size="60" /> Actualizar Estados Sub Menú
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
// eslint-disable-next-line import/no-duplicates
import FormAddMenu from '@/components/Menu/MenuProcess.vue'
// eslint-disable-next-line import/no-duplicates
import FormEditMenu from '@/components/Menu/MenuProcess.vue'
import draggable from 'vuedraggable'

export default {
  name: 'MenuList',
  components: {
    draggable,
    FormAddMenu,
    FormEditMenu,
  },
  data () {
    return {
      dataMenu: [],
      refNoMenu: false,
      menuModel: [],
      formUpdate: [],
      renderComponent1: false,
      renderComponent2: false,
      childref: [],
    }
  },
  methods: {
    LinkMenu () {
      return this.$router.push({ path: '/admin/Menu' })
    },
    addChild (refval, idref) {
      debugger
      if (!(typeof refval === 'undefined')) {
        this.childref[idref] = refval
      }
    },
    reloadMenu () {
      let loader = this.$loading.show()
      window.location.reload()
      loader.show()
    },
    editMenu (valorum) {
      this.formUpdate = valorum
      IberoHelpers.forceRerender2(this)
      this.$modal.show('EditMenu')
    },
    uptMenuActions (event, refe, val) {
      if (refe === 'Short') {
        event.Sta_ShortCuts = val
      } else if (refe === 'View') {
        event.Is_View = val
      } else if (refe === 'Active') {
        event.Sta_Active = val
      }
    },
    addMenu () {
      this.formUpdate = ''
      IberoHelpers.forceRerender1(this)
      this.$modal.show('AddMenu')
    },
    UpdateMenuList () {
      let loader = this.$loading.show()
      this.menuModel.length = 0
      for (var i = 0; i < this.dataMenu.length; i++) {
        this.menuModel.push({
          Id_Menu: this.dataMenu[i].Id_Menu,
          Des_OrderBy: i + 1,
          Sta_ShortCuts: this.dataMenu[i].Sta_ShortCuts,
          Is_View: this.dataMenu[i].Is_View,
          Sta_Active: this.dataMenu[i].Sta_Active,
        })
      }
      var UpdateMenu = IberoHelpers.updateMenu(this.$store, this.menuModel, 4)
      UpdateMenu.then(Response => {
        if (Response.data) {
          if (Response.data.message === 'Success') {
            this.reloadMenu()
          }
        } else {
          loader.hide()
          this.refNoMenu = true
        }
      })
    },
    loadListMenu () {
      var MenuData = IberoHelpers.getMenuData(this.$store, 3, this.$route.params.idMenu)
      MenuData.then(Response => {
        if (Response.data) {
          this.dataMenu = Response.data
        } else {
          this.refNoMenu = true
        }
      })
    },
  },
  created: function () {
    this.loadListMenu()
  },
}
</script>

<style scoped>
.refNoData {
  padding: 10px;
  padding-left: 20px;
  margin-top: 30px;
  margin-bottom: 10px;
}
.MenuData {
  margin-top: 20px;
}
td:hover {
  cursor: move;
}

.table thead th {
  border-bottom: 2px solid #222 !important;
  font-weight: bold;
}

.loginbtn{
    min-width: 250px !important;
}

.status{
  background: #F65A6F !important;
}

.submenu{
  display: none;
}
</style>